Namespace 'Monitoring.Reports.DailyInsights'

class Monitoring.Reports.DailyInsights.SentimentDistributionView extends Backbone.View

  className: 'sentiment-distribution'
  
  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.addClass('rendering')

    ancestors = [@options.post.id]
    ancestors = [@options.post.id]
    if @options.post.type == "instagramMedia"
      ancestors = @options.post.id.substring(0, @options.post.id.indexOf('-'))
      
    params = {
      account_id: @options.account_id,
      dimension: 'sentiment',
      ancestors: ancestors,
      not: { sub_type: ['retweet'] },
      exclude_page_owner_generated: true
    }

    $.post('/monitoring/api/charts/single_dimension', params, @_renderChart)

  _renderChart: (data) =>
    @series = {}
    for data in data.series[0].data
      @series[data.code] = data.y
    
    @_renderPie()
    
  chartSeries: =>
    if (@series.negative + @series.neutral + @series.positive) > 0
      series = [
        {
          name: 'Sentiment'
          data: [
            {
              name: I18n.t('monitoring.dashboard.charts.negative')
              color: @options.colors.negative
              y: @series.negative
            }
            {
              name: 'Neutral'
              color: @options.colors.neutral
              y: @series.neutral
            }
            {
              name: I18n.t('monitoring.dashboard.charts.positive')
              color: @options.colors.positive
              y: @series.positive
            }
          ]
        }
      ]
    else
      series = []

  _renderPie: =>
    @$el.highcharts({
      chart:
        type: 'pie'
        backgroundColor: "#FFFFFF"
        height: @options.sentimentHeight
        style: {fontFamily: "Roboto", "Helvetica Neue", "Helvetica", "Arial", "sans-serif"}        
      title: null       
      lang:
        noData: "No hay comentarios para analizar"
      plotOptions:
        pie:
          dataLabels:
            enabled: false
          showInLegend: true
          borderColor: null
      legend:
        labelFormat: '{name} - {y} ({percentage:.2f}%)'
      exporting:
        enabled: false
      series: @chartSeries()
    })
    @$el.removeClass('rendering')